import React, { useState } from 'react';

import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField/TextField';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

export default (props) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickToggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const { hidePasswordIcon, ...textProps } = props;

  return (
    <TextField
      fullWidth
      InputProps={{
        endAdornment: hidePasswordIcon ? null : (
          <InputAdornment>
            <IconButton aria-label="toggle password visibility" onClick={handleClickToggleShowPassword} onMouseDown={handleMouseDownPassword}>
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      type={showPassword ? 'text' : 'password'}
      {...textProps}
    />
  );
};
